export const services = [
  {
    title: 'Sanitärtechnik',
    description:
      'Moderne Badkonzepte, wasser- und abwasserführende Installationen sowie effiziente Wellnesslösungen aus einer Hand.',
    icon: '🚿',
  },
  {
    title: 'Heizsysteme',
    description:
      'Planung und Umsetzung von Heizungsanlagen inklusive Wärmepumpen und Hybridlösungen für nachhaltige Wärme.',
    icon: '🔥',
  },
  {
    title: 'Klimatechnik',
    description:
      'Individuell abgestimmte Lüftungs- und Klimageräte für Wohn- und Gewerbeobjekte – energieeffizient und leise.',
    icon: '❄️',
  },
  {
    title: 'Wartung & Service',
    description:
      'Regelmäßige Wartung, Notdienst und intelligente Monitoring-Lösungen für einen zuverlässigen Anlagenbetrieb.',
    icon: '🛠️',
  },
];

export const highlights = [
  { value: '25+', label: 'Jahre Erfahrung' },
  { value: '500+', label: 'Projekte realisiert' },
  { value: '24/7', label: 'Service & Notfall' },
];

export const steps = [
  {
    title: 'Beratung',
    description: 'Wir analysieren Ihre Anforderungen vor Ort und entwickeln ein maßgeschneidertes Konzept.',
  },
  {
    title: 'Planung',
    description:
      'Detaillierte Planung inklusive Materialdisposition, Zeitplan und transparenter Budgetübersicht.',
  },
  {
    title: 'Umsetzung',
    description: 'Zertifizierte Fachmonteure setzen das Projekt sauber, termingerecht und qualitativ hochwertig um.',
  },
  {
    title: 'Nachbetreuung',
    description: 'Wir bleiben Ihr Partner: Wartung, Optimierung und Notdienst sichern den langfristigen Betrieb.',
  },
];

export const testimonials = [
  {
    quote:
      'Schnelle Reaktionszeit, saubere Arbeit und eine persönliche Betreuung. Unsere Heizungsmodernisierung lief perfekt.',
    author: 'Julia K. · Hausverwaltung München',
  },
  {
    quote:
      'Von der Planung bis zur Umsetzung zuverlässig und professionell. Wir empfehlen Schnitter GbR Haustechnik weiter.',
    author: 'Thomas S. · Architekturbüro Schwabing',
  },
];
